<h1 mat-dialog-title>
    <span [translate]="'admin.entreprise.populations.liste.ajoutOrgaTitle'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content class="py-1">
    <form autocomplete="off">
        <fieldset>
            <div class="row">
                <custom-input ngDefaultControl
                              name="orgas"
                              libelle="admin.entreprise.populations.liste.service"
                              customType="autocomplete"
                              autocompleteType="service"
                              optionDisplay="libelle"
                              [idName]="'idOrga'"
                              [(ngModel)]="orga"
                              [lCol]="4"
                              [rCol]="7"
                              [required]="true">
                </custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="excludeOrga"
                              name="excludeOrga"
                              [ngModel]="isExcludeOrga"
                              [(customModel)]="isExcludeOrga"
                              customType="checkbox"
                              [lCol]="4"
                              libelle="admin.entreprise.populations.liste.exclureOrga">
                </custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="excludeSousOrga"
                              name="excludeSousOrga"
                              [ngModel]="isExcludeSousOrga"
                              [(customModel)]="isExcludeSousOrga"
                              customType="checkbox"
                              [lCol]="4"
                              libelle="admin.entreprise.populations.liste.exclureSousOrga">
                </custom-input>
            </div>
        </fieldset>
    </form>
</div>
<div class="action-row d-flex flex-row-reverse">
    <div class="end-actions">
        <button mat-flat-button color="primary" (click)="addOrga()">
            <span *ngIf="!isSaving" translate>global.actions.ajouter</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
    </div>
</div>

